import { createStyles } from '@material-ui/core'

export const stylesMui = (theme) =>
  createStyles({
    cardMedia: {
      maxHeight: '24%',
      maxWidth: '33%',
      marginRight: 'auto',
      marginLeft: 'auto',
      marginTop: 'auto',
      marginBottom: 'auto'
    },
    card: {
      maxWidth: '250px',
      minWidth: '250px',
      minHeight: '300px',
      maxHeight: '300px'
    },
    cardContent: {
      marginTop: theme.spacing(1)
    },
    cardContentTitle: {
      textAlign: 'center'
    },
    faPlus: {
      marginTop: '50%',
      marginLeft: '45%'
    },
    btnNew: {
      marginRight: '20%',
      marginLeft: '37%',
      marginTop: '17%'
    },
    btnNewWithFilters: {
      marginTop: '10%',
      marginLeft: '18%'
    }
  })
